<div class="flex flex-col gap-4">
  <mat-slide-toggle
    [checked]="toggleEnabled()"
    (change)="onToggleChange($event.checked)"
  >
    Include clinical notes in letter
  </mat-slide-toggle>

  @if (toggleEnabled()) {
    <pr-information-box>
      Selected clinical notes will be appended to the referral letter content.
    </pr-information-box>

    @if (clinicalNotes().length === 0) {
      <p class="text-sm text-slate-500">No clinical notes available.</p>
    } @else {
      <table
        class="w-full"
        mat-table
        multiTemplateDataRows
        [dataSource]="clinicalNotes()"
      >
        <ng-container matColumnDef="recordDate">
          <th *matHeaderCellDef mat-header-cell>
            <span class="font-bold">Recorded On</span>
          </th>
          <td *matCellDef="let record" mat-cell>
            {{ record.recordDate | moment | amDateFormat: dateFormat }}
          </td>
        </ng-container>

        <ng-container matColumnDef="recordedBy">
          <th *matHeaderCellDef mat-header-cell>
            <span class="font-bold">Recorded By</span>
          </th>
          <td *matCellDef="let record" mat-cell>
            {{ record.owner?.name }}
          </td>
        </ng-container>

        <ng-container matColumnDef="select">
          <th *matHeaderCellDef mat-header-cell class="w-12">
            <mat-checkbox
              [checked]="selectionList.isAllSelected$ | async"
              [indeterminate]="selectionList.isSomeSelected$ | async"
              (change)="onToggleAll()"
              (click)="$event.stopPropagation()"
            />
          </th>
          <td
            *matCellDef="let row"
            mat-cell
            class="w-12"
            (click)="$event.stopPropagation()"
          >
            <mat-checkbox
              [checked]="row | map: selectionList.isSelected$ : selectionList | async"
              (click)="onNoteToggle(row); $event.stopPropagation()"
            />
          </td>
        </ng-container>

        <ng-container matColumnDef="expand">
          <th
            *matHeaderCellDef
            mat-header-cell
            aria-label="row actions"
            class="w-12"
          >
            <button
              type="button"
              mat-icon-button
              aria-label="expand all rows"
              [matTooltip]="allExpanded() ? 'Collapse All' : 'Expand All'"
              (click)="toggleAllExpanded(); $event.stopPropagation()"
            >
              <mat-icon>
                {{ allExpanded() ? 'unfold_less' : 'unfold_more' }}
              </mat-icon>
            </button>
          </th>
          <td *matCellDef="let record" mat-cell class="w-12">
            <button
              type="button"
              mat-icon-button
              aria-label="expand row"
              (click)="toggle(record); $event.stopPropagation()"
            >
              <mat-icon>
                {{
                  isRecordExpanded()(record)
                    ? 'keyboard_arrow_up'
                    : 'keyboard_arrow_down'
                }}
              </mat-icon>
            </button>
          </td>
        </ng-container>

        <ng-container matColumnDef="expandedDetail">
          <td
            *matCellDef="let record"
            mat-cell
            class="bg-white p-0"
            [attr.colspan]="columnsToDisplay.length"
          >
            @if (isRecordExpanded()(record)) {
              <div class="p-4">
                <pr-content-view [content]="record.content" />
              </div>
            }
          </td>
        </ng-container>

        <tr *matHeaderRowDef="columnsToDisplay" mat-header-row></tr>
        <tr
          *matRowDef="let record; columns: columnsToDisplay"
          mat-row
          class="cursor-pointer hover:bg-gray-100"
          [ngClass]="{ 'expanded-row': isRecordExpanded()(record) }"
          (click)="toggle(record)"
        ></tr>
        <tr
          *matRowDef="let record; columns: ['expandedDetail']"
          class="h-0"
          mat-row
          [ngClass]="{
            hidden: !isRecordExpanded()(record),
            'content-row table-row': isRecordExpanded()(record)
          }"
        ></tr>
      </table>
    }
  }
</div>
